import { render, staticRenderFns } from "./AddSubjectLabelCategoryDialog.vue?vue&type=template&id=658d97ac"
import script from "@/views/SubjectLabelCategories/AddSubjectLabelCategoryDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/SubjectLabelCategories/AddSubjectLabelCategoryDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/SubjectLabelCategories/AddSubjectLabelCategoryDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports